var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-modal",class:_vm.style.infoModal},[_c('div',{staticClass:"modal-container"},[_vm._t("title"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('div',{staticClass:"modal-actions"},[_vm._t("actions")],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbfd775","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/strip-block-custom??ref--0-0!./src/components/InfoModal.vue
// module id = 2572
// module chunks = 1707 1721